<template>
    <div class="d-flex justify-content-between align-items-center">
        <div class="text-sm d-flex justify-content-center w-100">
            <p v-if="totalItems > 0" class="px-3 pt-3">
                Mostrando {{ showingStart }} a {{ showingEnd }} de {{ totalItems }} registros
            </p>
            <div v-else class="empty-state-wrapper-full">
                <EmptyStatePatients @create-patient="$emit('createFirst')" />
            </div>
        </div>
        <div v-if="lastPage > 1" class="mb-3 mt-2 me-4 ms-4">
            <div class="pagination">
                <!-- Botón de página anterior solo si no está en la primera página -->
                <button
v-if="currentPage > 1" class="page-item prev"
                    @click.prevent="changePage(currentPage - 1)">Anterior</button>

                <!-- Primer página siempre visible -->
                <button
:class="{ 'active': currentPage === 1 }" class="page-item"
                    @click.prevent="changePage(1)">1</button>

                <!-- Puntos suspensivos -->
                <span v-if="currentPage > 3" class="dots">...</span>

                <!-- Números de páginas centrales -->
                <button
v-for="page in centeredPages" :key="page" :class="{ 'active': page === currentPage }"
                    class="page-item" @click.prevent="changePage(page)">
                    {{ page }}
                </button>

                <!-- Puntos suspensivos -->
                <span v-if="currentPage < lastPage - 2" class="dots">...</span>

                <!-- Última página siempre visible -->
                <button
:class="{ 'active': currentPage === lastPage }" class="page-item"
                    @click.prevent="changePage(lastPage)">{{ lastPage }}</button>

                <!-- Botón de siguiente página solo si no está en la última página -->
                <button
v-if="currentPage < lastPage" class="page-item next"
                    @click.prevent="changePage(currentPage + 1)">Siguiente</button>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed, defineEmits } from 'vue';
import EmptyStatePatients from './EmptyStatePatients.vue';

const emit = defineEmits(['pageChange', 'createFirst']);

const props = defineProps({
    totalItems: Number,
    currentPage: Number,
    lastPage: Number,
    itemsPerPage: Number,
});

const showingStart = computed(() => {
    if (props.totalItems === 0 || props.currentPage < 1) return 0;
    return (props.currentPage - 1) * props.itemsPerPage + 1;
});

const showingEnd = computed(() => {
    if (props.totalItems === 0 || props.currentPage < 1) return 0;
    return Math.min(props.currentPage * props.itemsPerPage, props.totalItems);
});

const centeredPages = computed(() => {
    const pages = [];
    const startPage = Math.max(2, props.currentPage - 1);
    const endPage = Math.min(props.lastPage - 1, props.currentPage + 1);

    for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
    }
    return pages;
});

const changePage = (page) => {
    emit('pageChange', page);
};
</script>

<style scoped>
/* Contenedor del EmptyState */
.empty-state-wrapper {
    width: 100%;
    min-height: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem 1rem;
}

.empty-state-wrapper-full {
    width: 100%;
    min-height: 100vh;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding: 0;
    background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
}

.pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
}

.page-item {
    background-color: #f8f9fa;
    border: 1px solid #dee2e6;
    color: #007bff;
    cursor: pointer;
    padding: 0.5rem 1rem;
    font-size: 1rem;
    border-radius: 5px;
    transition: background-color 0.3s ease, color 0.3s ease;
}

.page-item:hover {
    background-color: #007bff;
    color: white;
}

.page-item.active {
    background-color: #007bff;
    color: white;
    cursor: default;
    pointer-events: none;
}

.page-item.disabled {
    color: #6c757d;
    pointer-events: none;
    cursor: not-allowed;
}

.page-item.prev,
.page-item.next {
    background-color: transparent;
    color: #007bff;
    font-weight: bold;
}

.page-item.prev:hover,
.page-item.next:hover {
    background-color: #007bff;
    color: white;
}
</style>
